module.exports = __webpack_public_path__ + "static/media/downloadSimple.53fc2176.svg";